import DeliveryCvna from '@carvana/ds-icons/DeliveryCvna';
import { icon } from '@carvana/ds-styles';
import cx from 'classnames';
import SortOption from '~/constants/common/SortOption';
import { appAssetsCdnUrl } from '~/constants/environment';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import { nativeSrpPayload } from '~/native/common/utils';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';
import optimizeImage from '~/utilities/optimizeImage';
import styles from './Cards.module.css';
import {
  CardContainer,
  CardCtaButton,
  CardSubtitle,
  CardTitle,
  CardTitleContainer
} from './Cards.styles';

const DELIVERY_BY_TOMORROW_SEARCH_LINK = generateSearchLinkFilter({
  sortBy: SortOption.AcquisitionTime
});

export default function NeedItFast() {
  const getHref = useGetConsumerHref();

  return (
    <CardContainer
      className="grid bg-brand-secondary !p-0"
      data-analytics-id="Need it Fast"
      data-testid="need-it-fast-card"
      data-native-payload={nativeSrpPayload}
      href={getHref(DELIVERY_BY_TOMORROW_SEARCH_LINK)}
    >
      <div className="relative col-span-full row-span-full flex h-full max-h-[365px] w-full bg-background-strong-active">
        <DeliveryCvna
          color={icon.inverse}
          className={cx(
            'absolute left-[204px] top-[184px] h-[37px] w-[37px]',
            styles.deliveryTruck
          )}
        />
        <img
          src={optimizeImage(
            `${appAssetsCdnUrl}/images/home/budget-delivery-tomorrow.png`,
            { height: 350, quality: 90, format: 'auto' }
          )}
          alt="Calendar with a stylized delivery truck on Friday the fourth"
          className="z-1 w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="z-1 col-span-full row-span-full flex flex-col items-center justify-between p-2xl">
        <CardTitleContainer>
          <CardTitle inverse>Need it fast?</CardTitle>
          <CardSubtitle inverse>
            Based on your location, we’ve got availability as soon as today!
          </CardSubtitle>
        </CardTitleContainer>
        <CardCtaButton
          data-analytics-id="Need it Fast"
          data-testid="shop-by-delivery-date"
          variant="primaryInverted"
        >
          Shop by Delivery Date
        </CardCtaButton>
      </div>
    </CardContainer>
  );
}
